<template>
  <icon-switch class="image-toggle" :value='showImage' @input='toggleImage' >
    🖼️
  </icon-switch>
</template>

<script>
import { defineComponent, inject, onMounted } from 'vue';
import IconSwitch from './IconSwitch.vue';

export default {
  components: { IconSwitch },
  setup(_, context){

    const showImage = inject('showImage');
    const toggleImage = (newVal)=>{
      console.log('image toggle: ' + newVal)
      showImage.value = newVal;
    } 

    return {
      showImage,
      toggleImage
    }
  }
};
</script>
